import { sendRequest } from "./api";

interface ITaskItem {

}

const route = 'calendar';

export const getTaskItems = () => {
    return sendRequest(route, 'GET', undefined, '');
}

// Transform task item to server format with Datetime field
const taskItemToServer = (item: any) => {
    const result = { ...item };
    
    // If Datetime is not set but start is provided, convert start to Datetime
    if (result.Datetime === undefined && item.start) {
        try {
            const startDate = item.start instanceof Date ? item.start : new Date(item.start);
            if (!isNaN(startDate.getTime())) {
                result.Datetime = Math.floor(startDate.valueOf() / 1000);
            }
        } catch (e) {
            console.warn('Failed to convert task item start date to UTC timestamp:', e);
        }
    }
    
    // Clean up client-only fields - keep editOtherEvents as backend expects it
    delete result.start;
    delete result.end;
    
    return result;
};

export const postTaskItem = (item: ITaskItem) => {
    return sendRequest(route, 'POST', taskItemToServer(item), '');
}

export const getTaskItem = (itemId: string) => {
    return sendRequest(route + '/', 'GET', undefined, itemId);
}

export const putTaskItem = (item: ITaskItem, itemId: string, editOtherEvents: boolean = false) => {
    return sendRequest(route + '/', 'PUT', {...taskItemToServer(item), "editOtherEvents": editOtherEvents}, itemId);
}

export const deleteTaskItem = (itemId: string, all?: boolean) => {
    return sendRequest(route + '/', 'DELETE', {
        action: all ? 'delete-all' : 'delete-single',
        includeThis: true,
        amount: 0
    }, itemId);
}

